export default {
  // Common actions
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.create': 'Create',
  'common.update': 'Edit',
  'common.search': 'Search',
  'common.reset': 'Reset',
  'common.refresh': 'Refresh',
  'common.filter': 'Filter',
  'common.submit': 'Submit',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.loading': 'Loading',
  'common.success': 'Success',
  'common.failed': 'Failed',
  'common.sendFailed': 'Failed to send',
  'common.registerFailed': 'Registration failed',
  'common.resetFailed': 'Failed to reset',
  'common.loginFailed': 'Login failed',
  'common.empty': 'No data',
  'common.more': 'More',
  'common.noPermission': 'You do not have permission to access this page',

  // Audio player
  'audio.play': 'Play',
  'audio.pause': 'Pause',
  'audio.download': 'Download',
  'audio.loadFailed': 'Failed to load audio',
  'audio.waveLimited': 'Waveform unavailable, playback still works',

  // Lists
  'list.total': '{total} records',

  // Attribution channel enums (aligned with backend attr channels)
  'attr.channel.paid_ads': 'Paid ads',
  'attr.channel.social': 'Social media',
  'attr.channel.email_sms': 'Email / SMS',
  'attr.channel.invite': 'Invite',
  'attr.channel.qr_offline': 'Offline QR',
  'attr.channel.organic_search': 'Organic search',
  'attr.channel.referral': 'Referral',
  'attr.channel.direct': 'Direct',
  'attr.channel.unknown': 'Unattributed',


  // Sidebar navigation (shared fixed entries)
  'nav.admin': 'Admin',
  'nav.admin.short': 'Admin',
  'nav.setting': 'Settings',
  'nav.admin.user': 'Users',
  'nav.admin.setting': 'Feature Settings',
  'nav.admin.register': 'Registration & Login',
  'nav.admin.package': 'Credit Packages',
  'nav.admin.order': 'Credit Purchases',
  'nav.admin.pay': 'Payment Settings',
  'nav.admin.notify': 'Operation Notifications',
  'nav.admin.attr': 'Channels',
  'nav.setting.basic': 'General',
  'nav.setting.upload': 'Upload',
  'nav.setting.file': 'Files',
  'nav.setting.smtp': 'Email',
  'nav.setting.sms': 'SMS',
  'nav.setting.about': 'About System',

  // Shell (sidebar footer actions / account modal)
  'shell.account': 'Account',
  'shell.feedback': 'Feedback',
  'shell.settings': 'Settings',
  'shell.account.title': 'Account Settings',
  'shell.logout': 'Log out',
  'shell.logout.title': 'Log out',
  'shell.logout.desc': 'Are you sure you want to log out?',
  'shell.logout.ok': 'Log out',

  // Account settings (modal tab forms)
  'shell.account.tabAvatar': 'Change Avatar',
  'shell.account.avatarUpload': 'Upload',
  'shell.account.avatarUploadNew': 'Upload avatar',
  'shell.account.avatarReset': 'Restore default',
  'shell.account.avatarUndo': 'Undo',
  'shell.account.avatarUndoSuccess': 'Restored the previous avatar',
  'shell.account.avatarEmptyHint': 'Default avatar in use. Click the avatar or "Upload avatar" to change it.',
  'shell.account.avatarFormatHint': 'JPG or PNG, 1:1 recommended, at least 200×200, up to 5MB',
  'shell.account.avatarResetTitle': 'Restore default avatar',
  'shell.account.avatarResetDesc': 'This removes your current avatar and restores the default one. Continue?',
  'shell.account.avatarUploadSuccess': 'Avatar uploaded',
  'shell.account.avatarUploadFailed': 'Avatar upload failed',
  'shell.account.avatarResetSuccess': 'Default avatar restored',
  'shell.account.tabUsername': 'Change Username',
  'shell.account.tabEmail': 'Change Email',
  'shell.account.tabPassword': 'Change Password',
  'shell.account.currentUsername': 'Current username',
  'shell.account.newUsername': 'New username',
  'shell.account.newUsernamePlaceholder': 'Please enter new username',
  'shell.account.saveUsername': 'Save username',
  'shell.account.usernameRequired': 'Please enter a new username',
  'shell.account.usernameSuccess': 'Username updated',
  'shell.account.currentEmail': 'Current email',
  'shell.account.emailUnset': 'Not set',
  'shell.account.newEmail': 'New email',
  'shell.account.newEmailPlaceholder': 'Used for password recovery',
  'shell.account.newEmailPlaceholderPlain': 'Enter a new email',
  'shell.account.saveEmail': 'Save email',
  'shell.account.emailRequired': 'Please enter a new email',
  'shell.account.emailSuccess': 'Email updated',
  'shell.account.emailCode': 'Email verification code',
  'shell.account.emailCodePlaceholder': 'Please enter the email verification code',
  'shell.account.emailCodeRequired': 'Please enter the email verification code',
  'shell.account.tabPhone': 'Change Phone',
  'shell.account.currentPhone': 'Current phone',
  'shell.account.phoneUnset': 'Not set',
  'shell.account.newPhone': 'New phone',
  'shell.account.newPhonePlaceholder': 'Enter a new phone number',
  'shell.account.savePhone': 'Save phone',
  'shell.account.phoneRequired': 'Please enter a new phone number',
  'shell.account.phoneInvalid': 'Invalid phone number',
  'shell.account.phoneSuccess': 'Phone updated',
  'shell.account.phoneCode': 'SMS verification code',
  'shell.account.phoneCodePlaceholder': 'Please enter the SMS verification code',
  'shell.account.phoneCodeRequired': 'Please enter the SMS verification code',
  'shell.account.sendCode': 'Send code',
  'shell.account.codeResend': 'Resend in {seconds}s',
  'shell.account.codeSent': 'Verification code sent',
  'shell.account.codeSendFailed': 'Failed to send verification code',
  'shell.account.currentPassword': 'Current password',
  'shell.account.currentPasswordPlaceholder': 'Please enter current password',
  'shell.account.newPassword': 'New password',
  'shell.account.newPasswordPlaceholder': 'Please enter new password',
  'shell.account.confirmPassword': 'Confirm new password',
  'shell.account.confirmPasswordPlaceholder': 'Please enter the new password again',
  'shell.account.savePassword': 'Save password',
  'shell.account.passwordAllRequired': 'Please fill in all password fields',
  'shell.account.passwordMismatch': 'The new passwords do not match',
  'shell.account.passwordSuccess': 'Password updated',
  'shell.account.updateFailed': 'Update failed',

  // Account modal sections (optional base modules)
  'shell.account.tabAccount': 'Basic Info',
  'shell.account.tabInfo': 'Edit Info',
  'shell.account.tabRecharge': 'Recharge',
  'shell.account.roleAdmin': 'Admin',
  'shell.account.roleUser': 'User',
  'shell.account.balance': 'Credit',
  'shell.account.pointsUnit': 'pts',
  'shell.account.goRecharge': 'Recharge',
  'shell.account.totalPurchased': 'Total purchased',
  'shell.account.totalConsumed': 'Total consumed',
  'shell.account.channel.alipay': 'Alipay',
  'shell.account.channel.wechat': 'WeChat Pay',
  'shell.account.channel.connect': 'ModStart Connect',
  'shell.account.recharge.package': 'Recharge package',
  'shell.account.recharge.channel': 'Payment method',
  'shell.account.recharge.credit': 'Credits',
  'shell.account.recharge.bonus': 'Bonus',
  'shell.account.recharge.submit': 'Recharge now',
  'shell.account.recharge.success': 'Recharge succeeded, credits added',
  'shell.account.recharge.failed': 'Recharge failed',
  'shell.account.recharge.emptyPackage': 'No packages available',
  'shell.account.recharge.noChannel': 'No payment method available',
  'shell.account.recharge.connectHint': 'Scan with Alipay or WeChat Pay',
  'shell.account.recharge.qrTitle': 'Scan to pay',
  'shell.account.recharge.qrHint': 'Scan the QR code with WeChat or Alipay to complete the payment',
  'shell.account.recharge.qrOrderNo': 'Order No.',
  'shell.account.recharge.qrWaiting': 'Waiting for payment. Credits will be added automatically.',
  'shell.account.recharge.qrSuccess': 'Payment succeeded, credits added',
  'shell.account.recharge.qrExpired': 'QR code expired, please refresh',
  'shell.account.recharge.qrRefresh': 'Refresh',
  'shell.account.recharge.qrFailed': 'Failed to generate the QR code',
  'shell.account.recharge.openPayPage': 'Open payment page',
  'shell.account.recharge.agreementPrefix': 'By recharging you agree to the',
  'shell.account.recharge.agreementName': 'Recharge Service Agreement',
  'shell.account.recharge.agreementTitle': 'Recharge Service Agreement',
  'shell.account.recharge.agreementEmpty': 'No content',
  'shell.account.order.title': 'Orders',
  'shell.account.order.view': 'Orders',
  'shell.account.order.tabOrders': 'Credit purchases',
  'shell.account.order.tabLogs': 'Credit history',
  'shell.account.order.colOrderNo': 'Order No.',
  'shell.account.order.colTitle': 'Package',
  'shell.account.order.colPrice': 'Amount',
  'shell.account.order.colRefundAmount': 'Refunded',
  'shell.account.order.colCredit': 'Credits',
  'shell.account.order.colStatus': 'Status',
  'shell.account.order.colCreatedAt': 'Time',
  'shell.account.order.colChange': 'Change',
  'shell.account.order.colBalance': 'Balance',
  'shell.account.order.colRemark': 'Remark',
  'shell.account.order.empty': 'No orders',
  'shell.account.order.emptyLog': 'No records',
  'shell.account.order.statusNew': 'Pending',
  'shell.account.order.statusPayed': 'Paid',
  'shell.account.order.statusClosed': 'Closed',
  'shell.account.order.statusRefunded': 'Refunded',
  'shell.account.order.statusPartRefunded': 'Partially refunded',

  // System monitor (shared OSMonitor component)
  'osMonitor.title': 'System Status',
  'osMonitor.autoRefresh': 'Auto refresh every 5s',
  'osMonitor.cores': '{count} cores · {model}',
  'osMonitor.legendCpu': 'CPU',
  'osMonitor.legendMem': 'Memory',
  'osMonitor.legendProcess': 'Process Memory',
  'osMonitor.mem': 'Memory',
  'osMonitor.processMem': 'Process Memory',
  'osMonitor.disk': 'Disk',
  'osMonitor.uptime': 'Uptime',
  'osMonitor.heapUsed': 'Heap Used',
  'osMonitor.heapTotal': 'Heap Total',
  'osMonitor.external': 'Stack',
  'osMonitor.arrayBuffers': 'Other',
  'osMonitor.realtimeChart': 'Realtime Monitor',
  'osMonitor.collecting': 'Collecting data, please wait...',
  'osMonitor.loadFailed': 'Failed to load, please refresh',

  // Markdown viewer (shared MarkdownViewer component)
  'markdownViewer.copy': 'Copy',
  'markdownViewer.copied': 'Copied',
  'markdownViewer.copyFailed': 'Copy failed',
}
